// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2dfzE","title":"ClientReferral_title__3JDty","itemText":"ClientReferral_itemText__2EMVq"};